/**
 * Lucide icon base styles
 */

.lucide {
  display: inline-flex;
  width: 1em;
  height: 1em;
  vertical-align: -0.125em;
}

.lucide-sm {
  width: 0.875em;
  height: 0.875em;
}
